import { render, staticRenderFns } from "./meb-biographie.vue?vue&type=template&id=ece79188&scoped=true&"
import script from "./meb-biographie.vue?vue&type=script&lang=js&"
export * from "./meb-biographie.vue?vue&type=script&lang=js&"
import style0 from "./meb-biographie.vue?vue&type=style&index=0&id=ece79188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece79188",
  null
  
)

export default component.exports